import React, {Component, Fragment} from 'react';
import style from '../css/gameSubTab.css';
import {selectGame} from "../../../actions/gamesActions";
import {setselectedMatchdaySubEventIndex} from "../../../actions/eventsActions";
import connect from "react-redux/es/connect/connect";
import {getModuleFromEventType} from "../../../helpers/moduleHelpers";
import {
    AMERICAN_FOOTBALL_MODULE, BASEBALL_MODULE,
    BASKETBALL_MODULE, CRICKET_MODULE,
    FOOTBALL_MODULE,
    RES, TENNIS_MODULE,
    VPP_MATCHDAY_GREEK_CHANNEL
} from "../../../constants/identifiers";
import RacingCard from "../modules/racing/containers/racingCard";
import SelectedFootballCard from "../modules/football/containers/selectedFootballCard";
import SelectedBasketballCard from "../modules/basketball/containers/selectedBasketballCard";
import SelectedMatchdayEventCard from "../modules/matchday/containers/selectedMatchdayEventCard";
import {getText} from "../../../helpers/localization";
import SelectedAmericanFootballCard from "../modules/americanFootball/containers/selectedAmericanFootballCard";
import {calculateTimeDifference} from '../../../helpers/helperFunctions';
//const goalTimingsJson = require('../../../../src/constants/configurations/goalTimings.json');

let isClickable = true;
let previousScore = [];
const mapStateToProps = (state, ownProps) => {
    return {
        events: state.vpp.events,
        games: state.vpp.games,
        selectedGameIndex: state.vpp.selectedGameIndex,
        nextEventsTimeStamp: state.vpp.nextEventsTimeStamp,
        selectedMatchdaySubEventIndex: state.vpp.selectedMatchdaySubEventIndex,
        serverTimeOffset: state.vpp.serverTimeOffset
    };
};

class GameSubTab extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            events: storeData.vpp.events,
            games: storeData.vpp.games,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            selectedMatchdaySubEventIndex: storeData.vpp.selectedMatchdaySubEventIndex,
            serverTimeOffset: storeData.vpp.serverTimeOffset,
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                events: storeData.vpp.events,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
                serverTimeOffset: storeData.vpp.serverTimeOffset,
                games: storeData.vpp.games,
                selectedMatchdaySubEventIndex: storeData.vpp.selectedMatchdaySubEventIndex,
            });
        }
    }

    componentDidMount() {
        this.interval = setInterval(() => this.setState({time: Date.now()}), 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    _clickTab(matchdayEvent, game, index) {
        if (this.props.store && isClickable) {
            let selectedIndex = this.state.games.findIndex((storeGame, index) => storeGame.gameOrder === game.displayOrder && storeGame.categoryOrder === game.category.displayOrder);
            isClickable = false;
            setTimeout(() => {
                isClickable = true;
            }, 300);
            this.props.store.dispatch(matchdayEvent ? setselectedMatchdaySubEventIndex(index, this.props.store) : selectGame(selectedIndex, this.props.store));
            if (matchdayEvent)
                this.state.selectedMatchdaySubEventIndex = index;
        }
    }

    _getMatchdayEventLiveScore(matchdayEvent) {
        let goalTimings = this.state.games[this.state.selectedGameIndex].goalTimings;

        let timeDiff = calculateTimeDifference(matchdayEvent.eventTime, new Date(Date.now() - this.state.serverTimeOffset));

        let selectedEventGoals = goalTimings !== undefined ? goalTimings.filter(goalTiming => (parseInt(goalTiming.eventID, 10) === matchdayEvent.eventId)
            && parseInt(goalTiming.timeMs, 10) < parseInt(timeDiff, 10)) : undefined;

        let score;
        if (selectedEventGoals === undefined || selectedEventGoals.length < 1)
            score = "0-0";
        else {
            score = selectedEventGoals[selectedEventGoals.length - 1].score;
        }
        if (this.state.games[this.state.selectedGameIndex].controllerState !== undefined
            && this.state.games[this.state.selectedGameIndex].controllerState[matchdayEvent.order] !== undefined
            && this.state.games[this.state.selectedGameIndex].controllerState[matchdayEvent.order] === RES) {
            score = score + " " + getText('FT', this.props.store);
        }

        return score;
    }

    render() {
        let selectedBanner;
        let gameSubTab;
        let isSelected = this.props.game.name === this.state.games[this.state.selectedGameIndex].name
            && (this.props.matchdayEvent ? this.props.index === this.state.selectedMatchdaySubEventIndex : true);
        let isRacing = this.state.games[this.state.selectedGameIndex].type === 'racing';
        let gameSubTabStyle = isSelected ? `${style.subTabGame} ${style.subTabGameSelected}` : `${style.subTabGame}`;
        let noFutureEventsCard;

        let teamNamestyle = this.props.matchdayEvent ? (this.props.matchdayEvent.channel === VPP_MATCHDAY_GREEK_CHANNEL ? style.teamNameGreek : style.teamName) : '';
        let store = this.props.store;
        let storeData = store.getState();
        if (storeData.vpp.nextEventsTimeStamp.find((event) => event.channel === storeData.vpp.games[this.state.selectedGameIndex].channel && Number(event.eventTime)) === undefined) {
            noFutureEventsCard = true;
        }
        if (this.props.matchdayEvent) {
            selectedBanner = (<Fragment><SelectedMatchdayEventCard id='selectedMatchdayEventCard'
                                                                   store={this.props.store}
                                                                   event={this.props.matchdayEvent}/></Fragment>);
        } else if (this.state.events && this.state.events[0] && this.state.events[0].channel === this.state.games[this.state.selectedGameIndex].channel) {

            let module = getModuleFromEventType(this.state.events[0].eventType);
            switch (module) {
                case FOOTBALL_MODULE:
                    selectedBanner = (<Fragment><SelectedFootballCard id='selectedFootballCard'
                                                                      store={this.props.store}
                                                                      showActive={true}/></Fragment>);
                    break;
                case BASKETBALL_MODULE:
                    selectedBanner = (<Fragment><SelectedBasketballCard id='selectedBasketballCard'
                                                                        store={this.props.store}
                                                                        showActive={true}/></Fragment>);
                    break;
                case AMERICAN_FOOTBALL_MODULE:
                    selectedBanner = (<Fragment><SelectedAmericanFootballCard id='selectedAFCard'
                                                                              store={this.props.store}
                                                                              showActive={true}/></Fragment>);
                    break;
                case CRICKET_MODULE:
                    selectedBanner = (<Fragment>{getText((this.props.game.category.name + '_' + this.props.game.name).replace(/\s+/g, '_'), this.props.store)}</Fragment>);
                    break;
                case TENNIS_MODULE:
                    selectedBanner = (<Fragment>{getText((this.props.game.category.name + '_' + this.props.game.name).replace(/\s+/g, '_'), this.props.store)}</Fragment>);
                    break;
                case BASEBALL_MODULE:
                    selectedBanner = (<Fragment>{getText((this.props.game.category.name + '_' + this.props.game.name).replace(/\s+/g, '_'), this.props.store)}</Fragment>);
                    break;
            }
        }
        let scoreStyle = style.liveScore;
        let currentScore;
        if (this.props.matchdayEvent) {
            currentScore = this._getMatchdayEventLiveScore(this.props.matchdayEvent);
            scoreStyle = currentScore === previousScore[this.props.index] ? style.liveScore : `${style.liveScore} ${style.slidingHorizontal}`;
            previousScore[this.props.index] = currentScore;
        }
        gameSubTab = (<div id={'gamesubTab_' + this.props.index} className={gameSubTabStyle}
                           onClick={() => this._clickTab(this.props.matchdayEvent, this.props.game, this.props.index)}>
            <div className={style.subTabContainer}>
                <div className={teamNamestyle}>{this.props.matchdayEvent ?
                    getText('Matchday_' + this.props.matchdayEvent.teamOne, this.props.store).concat('-').concat(getText('Matchday_' + this.props.matchdayEvent.teamTwo, this.props.store))
                    : getText((this.props.game.category.name + '_' + this.props.game.name).replace(/\s+/g, '_'), this.props.store)}</div>

                <div className={`${scoreStyle}`}><span>{this.props.matchdayEvent ? currentScore : null}</span></div>
            </div>
        </div>);
        let displayText = isSelected && !isRacing && !noFutureEventsCard ? (
            <div className={gameSubTabStyle}>{selectedBanner}</div>) : gameSubTab;
        return (
            <Fragment>
                {displayText}
            </Fragment>
        );

    }
}

export default connect(mapStateToProps)(GameSubTab);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/gameSubTab.js